import { FormlyFieldConfig } from '@ngx-formly/core';
import { Selector } from '@ngxs/store';

import { DatasheetGroup } from '../../models/datasheet.model';
import { DatasheetFormlyUtils } from '../../utils/datasheet-formly.utils';
import { DATASHEET_STATE_TOKEN, DatasheetStateModel } from './datasheet.model';

export class DatasheetSelectors {
  @Selector([DATASHEET_STATE_TOKEN])
  static getDatasheet(state: DatasheetStateModel) {
    return state.groups;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getMessages(state: DatasheetStateModel) {
    return state.messages;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getEditedValues(state: DatasheetStateModel) {
    return state.editedValues;
  }

  @Selector([DatasheetSelectors.getDatasheet])
  static getSectionTables(groups: DatasheetGroup[]): FormlyFieldConfig[] {
    return DatasheetFormlyUtils.getSectionTables(groups);
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getSelectedGroup(state: DatasheetStateModel) {
    return state.groupId;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getSelectedSection(state: DatasheetStateModel) {
    return state.sectionId;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getSelectedRow(state: DatasheetStateModel) {
    return state.rowKey;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getForm(state: DatasheetStateModel) {
    return state.form;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getIsEditing(state: DatasheetStateModel) {
    return state.isEditing;
  }

  @Selector([DATASHEET_STATE_TOKEN])
  static getSomethingEdited(state: DatasheetStateModel) {
    return Object.entries(state.editedValues).length > 0;
  }
}
